// Local Storage를 이용한 영속성 저장소
const storage = {
  get(key, defaultValue = null) {
    const value = localStorage.getItem(key)
    if (value === null) {
      return defaultValue
    }
    return JSON.parse(value)
  },
  set(key, value) {
    return localStorage.setItem(key, JSON.stringify(value))
  }
}

export default storage